/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CreateSEOBody,
  GetSEOResponse,
  UpdateSEOBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateSEOBodyFromJSON,
    CreateSEOBodyToJSON,
    GetSEOResponseFromJSON,
    GetSEOResponseToJSON,
    UpdateSEOBodyFromJSON,
    UpdateSEOBodyToJSON,
} from '../models/index';

export interface CreateSeoSeoTagsRequest {
    createSEOBody?: CreateSEOBody;
}

export interface GetSeoSeoTagsRequest {
    url: string;
}

export interface UpdateSeoSeoTagsRequest {
    updateSEOBody?: UpdateSEOBody;
}

/**
 * SEOApi - interface
 * 
 * @export
 * @interface SEOApiInterface
 */
export interface SEOApiInterface {
    /**
     * Used to create a new entry for a SEO tags for the given url
     * @param {CreateSEOBody} [createSEOBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SEOApiInterface
     */
    createSeoSeoTagsRaw(requestParameters: CreateSeoSeoTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to create a new entry for a SEO tags for the given url
     */
    createSeoSeoTags(requestParameters: CreateSeoSeoTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to get a list of all SEO tags for the given url
     * @param {string} url 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SEOApiInterface
     */
    getSeoSeoTagsRaw(requestParameters: GetSeoSeoTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSEOResponse>>;

    /**
     * Used to get a list of all SEO tags for the given url
     */
    getSeoSeoTags(requestParameters: GetSeoSeoTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSEOResponse>;

    /**
     * Used to update the list of SEO tags for the given url.
     * @param {UpdateSEOBody} [updateSEOBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SEOApiInterface
     */
    updateSeoSeoTagsRaw(requestParameters: UpdateSeoSeoTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update the list of SEO tags for the given url.
     */
    updateSeoSeoTags(requestParameters: UpdateSeoSeoTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class SEOApi extends runtime.BaseAPI implements SEOApiInterface {

    /**
     * Used to create a new entry for a SEO tags for the given url
     */
    async createSeoSeoTagsRaw(requestParameters: CreateSeoSeoTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/seo/seo-tags`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSEOBodyToJSON(requestParameters['createSEOBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to create a new entry for a SEO tags for the given url
     */
    async createSeoSeoTags(requestParameters: CreateSeoSeoTagsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createSeoSeoTagsRaw(requestParameters, initOverrides);
    }

    /**
     * Used to get a list of all SEO tags for the given url
     */
    async getSeoSeoTagsRaw(requestParameters: GetSeoSeoTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSEOResponse>> {
        if (requestParameters['url'] == null) {
            throw new runtime.RequiredError(
                'url',
                'Required parameter "url" was null or undefined when calling getSeoSeoTags().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['url'] != null) {
            queryParameters['url'] = requestParameters['url'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/seo/seo-tags`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSEOResponseFromJSON(jsonValue));
    }

    /**
     * Used to get a list of all SEO tags for the given url
     */
    async getSeoSeoTags(requestParameters: GetSeoSeoTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSEOResponse> {
        const response = await this.getSeoSeoTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to update the list of SEO tags for the given url.
     */
    async updateSeoSeoTagsRaw(requestParameters: UpdateSeoSeoTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/seo/seo-tags`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSEOBodyToJSON(requestParameters['updateSEOBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update the list of SEO tags for the given url.
     */
    async updateSeoSeoTags(requestParameters: UpdateSeoSeoTagsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSeoSeoTagsRaw(requestParameters, initOverrides);
    }

}
